import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router';

import { fmtDate } from '../ops/format';
import { useProject } from '../projects/context';
import { projectKeys, useProjectApi } from '../projects/useProjectApi';
import { fmtCents, invoiceStatusLabels, mandateKindLabels } from './format';

// MandatesSection: erteilte Aufträge eines Maklers (Makler-Seite) – mit Auftragspreis und offener Abrechnung bei Partnern.
export function MandatesSection({ userId }: { userId: string }) {
  const { project } = useProject();
  const papi = useProjectApi();
  const base = `/p/${project.key}`;
  const q = useQuery({ queryKey: projectKeys.mandates(project.id, userId), queryFn: ({ signal }) => papi.mandates(userId, signal), retry: false });
  if (q.isPending || q.isError) return null;
  const items = q.data.items;
  const open = items.reduce((sum, m) => sum + m.open_cents, 0);
  return (
    <section className="card" aria-labelledby="mandates-title">
      <h2 id="mandates-title">Erteilte Aufträge</h2>
      {items.length === 0 ? (
        <p className="muted">Noch keine Aufträge gemeldet.</p>
      ) : (
        <div className="table-wrap">
          <table className="table">
            <thead>
              <tr>
                <th>Erteilt am</th>
                <th>Eigentümer</th>
                <th>Art</th>
                <th className="num">Auftragspreis</th>
                <th>Rechnung</th>
                <th className="num">Offen</th>
              </tr>
            </thead>
            <tbody>
              {items.map((m) => (
                <tr key={m.id} className={m.status === 'CANCELED' ? 'muted' : undefined}>
                  <td>{fmtDate(m.granted_on)}</td>
                  <td>
                    <Link to={`${base}/leads/${m.lead_id}`}>{m.lead_name || 'Lead'}</Link>
                    <small className="muted block">{m.place}</small>
                  </td>
                  <td>
                    {mandateKindLabels[m.kind]}
                    {m.status === 'CANCELED' && <span className="badge badge-muted">zurückgenommen</span>}
                    {m.is_test && <span className="badge badge-warn">Test – keine Abrechnung</span>}
                  </td>
                  <td className="num">{m.price_cents != null ? fmtCents(m.price_cents) : '–'}</td>
                  <td>
                    {m.invoice_status ? (
                      <>
                        {m.invoice_number ?? 'Entwurf'}
                        <small className="muted block">{invoiceStatusLabels[m.invoice_status]}</small>
                      </>
                    ) : (
                      '–'
                    )}
                  </td>
                  <td className="num">{m.open_cents > 0 ? fmtCents(m.open_cents) : '–'}</td>
                </tr>
              ))}
            </tbody>
            {open > 0 && (
              <tfoot>
                <tr>
                  <th scope="row" colSpan={5}>
                    Zur Abrechnung vorgemerkt
                  </th>
                  <td className="num price-strong">{fmtCents(open)}</td>
                </tr>
              </tfoot>
            )}
          </table>
        </div>
      )}
    </section>
  );
}
